import { memo } from 'react';
const SvgTwitch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="twitch_svg__feather twitch_svg__feather-twitch"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7" />
  </svg>
);
const Memo = memo(SvgTwitch);
export default Memo;
